import Api from './api';

const GeneralService = {
  balances: () =>
    Api.get('/amc/distributorBalances', {
      headers: { Authorization: sessionStorage.getItem('token') },
    }),

  transactions: () =>
    Api.get('/amc/transactions?idTransacaoDistribuidor=1', {
      headers: { Authorization: sessionStorage.getItem('token') },
    }),

  totalCadsInUse: (userType) =>
    Api.get(
      `/adm/historyParkings?userType=${userType}&isParked=true&limit=1000`,
      { headers: { Authorization: sessionStorage.getItem('token') } },
    ),
};

export default GeneralService;
